import Vue from "vue";
export default {
  // GET_USER(state, payload) {
  //   state.user = payload;
  // },

  GET_volunteerbylocation(state, payload) {
    state.get_volunteer_by_location = payload;
  },
  GET_VOLUNTEER_BY_SERVICE(state, payload) {
    state.getVolunteerByService = payload;
  },
  GET_VOLUNTEER_BY_DESIGNATION(state, payload) {
    state.getVolunteerByDesignation = payload;
  },
  SET_SEARCH_VALUE(state, payload) {
    state.searchTerm = payload;
  },
  GET_volunteerbyid(state, payload) {
    //state.get_volbyid.unshift(...payload);
    state.get_volbyid = payload;
  },
  GET_allreviewbyid(state, payload) {
    state.get_allreviewbyid = payload;
  },
  User_volbooking(state, payload) {
    state.user_volbooking = payload;
  },
  GETALL_booking(state, payload) {
    state.get_allbookingvol = payload;
  },
  GET_volunteerbooking(state, payload) {
    state.get_volunteerbooking = payload;
  },
  ADD_review(state, payload) {
    state.add_review = payload;
  },
  GET_volunteerbyuserid(state, payload) {
    state.get_volunteerbyuserId = payload;
  },
  GETALL_Bookingcounts(state, payload) {
    state.get_allbookingcounts = payload;
  },
  GETALL_Upcomingbooking(state, payload) {
    state.get_upcomingbooking = payload;
  },
  GETALL_Completedbooking(state, payload) {
    state.get_completedbooking = payload;
  },
  GETALL_Requirement(state, payload) {
    state.getall_requirement = payload;
  },
  GET_Volunteerbyadmin(state, payload) {
    state.get_volunteer_by_admin = payload;
  },
  GET_Allcount(state, payload) {
    state.get_all_count = payload;
  },
  SET_Location(state, payload) {
    state.get_location = payload;
  },
  ADD_Location(state, payload) {
    state.add_location = payload;
  },
  GET_LocationByName(state, payload) {
    state.get_location_by_name = payload;
  },
  GET_AllLocation(state, payload) {
    state.get_all_location = payload;
  },
  GET_AllLocationName(state, payload) {
    state.get_all_location_name = payload;
  },
  EDIT_Location(state, payload) {
    state.edit_location = payload;
  },
  DELETE_Location(state, payload) {
    state.delete_location = payload;
  },
  SERVICE_DISCOUNT(state, payload) {
    state.serviceDiscount = payload;
  },

  GET_ALL_WITHDRAWALS(state, payload) {
    state.allWithdrawalRequest = payload;
  },

  GET_WITHDRAWALS(state, payload) {
    state.withdrawalRequest = payload;
  },
};
